export default {
    // prod:
    CLOUDDRIVE_API_ENDPOINT: 'https://s9a0ldrnea.execute-api.us-east-2.amazonaws.com/default/',
    // connect:
    // CLOUDDRIVE_API_ENDPOINT: 'https://vbbfqk3nr4.execute-api.us-west-2.amazonaws.com/default/',
    //nonprod:
    // CLOUDDRIVE_API_ENDPOINT: 'https://jx0ah2eadg.execute-api.us-east-2.amazonaws.com/default/',
    //CLOUDDRIVE_API_ENDPOINT: 'https://4280f4fdad.execute-api.us-east-2.amazonaws.com/default/',
    // CLOUDDRIVE_API_ENDPOINT: 'http://localhost:8080/',
    //set false for connect, true for prod:
    SEND_EMAILS: true
}